import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

import { DocumentViewMode } from '@/model/universal';
import ImageCard from '@/components/shared/ImageCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageLoadingCard',
  props: {
    class: {},
    viewMode: {},
    limit: {},
    isFetching: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(
			(_ctx.viewMode !== _unref(DocumentViewMode).List
				? 'grid grid-cols-[repeat(auto-fill,_minmax(8rem,_1fr))]'
				: 'flex flex-col') +
			(' gap-2 sm:gap-4 !z-10 ' + props.class)
		)
  }, [
    (_ctx.isFetching)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Array(_ctx.limit), (_, index) => {
          return (_openBlock(), _createBlock(ImageCard, {
            key: index,
            viewMode: _ctx.viewMode,
            isLoading: _ctx.isFetching
          }, null, 8, ["viewMode", "isLoading"]))
        }), 128))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 2))
}
}

})